import React, { useState, useEffect } from "react";
import { Icon, Row, Col, Button, Statistic, Progress    } from "antd";
import moment from "moment";
import { secons2text } from "../../services/timeFunctions";
import { Wrapper, H3 } from "./styles";
import Table from "../../components/table";
import Search from "../../components/table/search";
import useManufacturingOrder from '../../hooks/useManufacturingOrder';
import useInterval from '../../hooks/useInterval';
import { useTranslation } from 'react-i18next';
import Colors from "../../theme/colors";
import { marksAgitation } from "../../constants";

const temperaturePrograming = 900;

const RenderFurnace = ({quenchingStatus}) => {
  const [corrienteEstado] = useState(600);
  const [frecuenciaEstado] = useState(10);
  const [tiempoEstado] = useState(50);
  const [manufacturingList, setManufacturingList] = useState(null);
  const [availableArticle, setAvailableArticle] = useState(null);
  const [furnaceArticle, setFurnaceArticle] = useState(null);
  const [count2Furnace, setCount2Furnace] = useState(0);
  const [furnaceNowTemperature, setFurnaceNowTemperature] = useState(900);
  const { manufacturingOrder, updateData } = useManufacturingOrder();
  const { t } = useTranslation();

  useInterval(() => {
    if(furnaceNowTemperature < temperaturePrograming) {
      setFurnaceNowTemperature(prevState => prevState+10);
      localStorage.setItem('furnaceTemp', furnaceNowTemperature);
    }
  }, 1000);

  useInterval(() => {
    setFurnaceArticle([...furnaceArticle]);
  }, 1000);

  useEffect(()=>{
  },[manufacturingOrder])

  useEffect(()=>{
    let temp = localStorage.getItem('furnaceTemp');
    if (temp) setFurnaceNowTemperature(parseInt(temp));
  },[])

  useEffect(() => {
    const filtered = manufacturingOrder.filter((order, i) => order.desing);
    const normalized = filtered.map((order, i) => {
      return {
        key: i,
        ...order
      };
    });
    let  n2Furnace = 0;
    const availableList = [];
    const intoFurnaceList = [];
    filtered.forEach((order, i) => {
      order.pieces.forEach((piece, x) => {
        if(!piece.furnace) n2Furnace++;
        let a = {
          key: x+"-"+piece.id,
          ...piece,
          ref: order.ref,
          furnace: order.desing.furnace,
          furnaceTime: piece.furnace,
          timeFurnace: 50,
          quenching: order.desing.quenching,
          tempered: order.desing.quenching
        };
        if(!piece.furnace) availableList.push(a);
        if(piece.furnace && piece.furnace.start && !piece.furnace.end) intoFurnaceList.push(a);
      });
    });

    setCount2Furnace(n2Furnace);
    setAvailableArticle(availableList);
    console.log(availableList);
    setFurnaceArticle(intoFurnaceList);

    normalized && setManufacturingList(normalized);
  }, [manufacturingOrder]);

  const columnsOrders = [
    {
      title: t('table.header.ref'),
      dataIndex: "ref",
      key: "ref",
      sorter: (a, b) => a.ref.localeCompare(b.ref),
      defaultSortOrder: "descend"
    },
    {
      title: t('table.header.article'),
      dataIndex: "article.articleName",
      key: "article.articleName"
    },
    {
      title: t('table.header.percent_pieces_furnace'),
      dataIndex: "pieces",
      key: "pieces",
      render: (text, record) => {
        if(!record.pieces) return;
        let ended = record.pieces.reduce((total,x) => (x.furnace && x.furnace.end ? total+1 : total), 0);
        let percent = 100*ended/record.pieces.length;
        
        return (
          <div style={{ width: "100%" }}>
            <Progress percent={percent} size="small" />
          </div>
        )
      }
    }
  ];


  const columnsAvailable = [
    {
      title: t("table.header.ref"),
      dataIndex: "ref",
      key: "ref",
      sorter: (a, b) => a.ref.localeCompare(b.ref),
      defaultSortOrder: "descend",
      ...Search("ref"),
    },
    {
      title: t("table.header.number"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("table.header.furnace_temp"),
      dataIndex: "furnace.temperature",
      key: "furnace.temperature",
    },
    {
      title: t("table.header.quenching_temp"),
      dataIndex: "quenching.bath_temperature",
      key: "quenching.bath_temperature",
    },
    {
      title: t('table.header.action'),
      dataIndex: "furnace",
      key: "furnace",
      render: (text, record) => {
        return (
          <div>
            <Button 
              type="link" 
              size="small" 
              disabled={!(record.furnace.corriente === corrienteEstado && record.furnace.frecuencia === frecuenciaEstado && record.furnace.tiempoExposicion === tiempoEstado)}
              onClick={() => article2furnace(record.id, record.ref)}
            >
              {t('button.action.to_furnace')}
              <Icon type="right" />
            </Button>
          </div>
        )
      }
    }
  ];

  const columnsFurnace = [
    {
      title: t('table.header.ref'),
      dataIndex: "ref",
      key: "ref",
      sorter: (a, b) => a.ref.localeCompare(b.ref),
      defaultSortOrder: "descend"
    },
    {
      title: t('table.header.number'),
      dataIndex: "id",
      key: "id"
    },
    {
      title: t('table.header.entry_date'),
      dataIndex: "furnaceTime.start",
      key: "furnaceTime.start",
      render: value => value.format("DD/MM/YYYY HH:mm:ss")
    },
    {
      title: t('table.header.exit_date'),
      dataIndex: "timeFurnace",
      key: "timeFurnace",
      render: (timeFurnace, record) => {
        let start = record.furnaceTime.start;
        let sec = start.unix();
        return moment((sec+timeFurnace)*1000).format("DD/MM/YYYY HH:mm:ss")
      }
    },
    {
      title: t('table.header.remaining_time'),
      dataIndex: "timeFurnace",
      key: "timeFurnace",
      render: (timeFurnace, record) => {
        let start_sec = record.furnaceTime.start.unix();
        let end_sec = start_sec+timeFurnace;
        let plusTime = (record.furnaceTime.plusTime) ? record.furnaceTime.plusTime : 0;
        let this_sec = moment().unix() + plusTime;
        let difference = end_sec-this_sec;
        let negative = difference < 0;

        return (negative) ?  <h3 style={{color: "red"}}>{"- " + secons2text(-1*difference)}</h3> : <h3>{secons2text(difference)}</h3>;
      }
    },
    {
      title: t('table.header.action'),
      dataIndex: "furnace",
      key: "furnace",
      render: (text, record) => {
        let start_sec = record.furnaceTime.start.unix();
        let end_sec = start_sec+record.furnaceTime.time;
        let plusTime = (record.furnaceTime.plusTime) ? record.furnaceTime.plusTime : 0; 
        let this_sec = moment().unix() + plusTime;
        let difference = end_sec-this_sec;
        let disabled = difference > 0;

        return (
          <div>
            <Button 
              type="link" 
              size="small" 
              disabled={disabled}
              onClick={() => article2out(record.id, record.ref)}
            >
              {t('button.action.takeF')}
              <Icon type="right" />
            </Button>
        </div>
        )
      }
    }
  ];


  const article2furnace = (id, ref) => {
    let order = manufacturingOrder.find(obj => obj.ref === ref)
    let list = order.pieces.map(obj => {
      if (obj.id === id) {
        return {
          ...obj,
          furnace: {
            start: moment()
          }
        }
      }else return obj
    })
    order.pieces = list;
    order.making = true;
    updateData(order)
  }

  const article2out = (id, ref) => {
    let order = manufacturingOrder.find(obj => obj.ref === ref)
    let list = order.pieces.map(obj => {
      if (obj.id === id) {
        return {
          ...obj,
          furnace: {
            ...obj.furnace,
            end: moment()
          },
          quenching:{
            start:moment()
          }
        }
      }else return obj
    })
    order.pieces = list;
    updateData(order)
  }

  const timeRunFurnace = (seconds) => {
    
    manufacturingOrder.forEach((order) => {
      if(order.making) {
        let list = order.pieces.map(obj => {
          if( obj.furnace && obj.furnace.start && !obj.furnace.end) {
            
            let plusTime = (obj.furnace.plusTime) ? obj.furnace.plusTime : 0; 
            let tm = plusTime < 0 ? plusTime - seconds : plusTime + seconds
            return {
              ...obj,
              furnace: {
                ...obj.furnace,
                plusTime: tm
              }
            }
            
          }else return obj;
        });
        order.pieces = list;
        updateData(order)
      }
    });
    
  }

  return (
    <Wrapper>
        <Row style={{ margin: 0 }} gutter={[16, 16]}>
            <Col xl={11} lg={11} md={24}>
                <H3>{t('headers.control_process.available_pieces', {value: count2Furnace})}</H3>
                <Table data={availableArticle} columns={columnsAvailable} pagination={{ pageSize: 5 }}/>
            </Col>
            <Col xl={2} lg={2} md={24}>
              <H3>{t('headers.control_process.status')}</H3>
              <Col span={24}>
                <Statistic
                  title={t("labels.state.furnace_temp")}
                  value={furnaceNowTemperature}
                  precision={2}
                  valueStyle={{ color: furnaceNowTemperature !== temperaturePrograming ? Colors.primary : Colors.success }}
                  prefix={furnaceNowTemperature !== temperaturePrograming && <Icon type="arrow-up" />}
                  suffix="ºC"
                  style={{ textAlign: "center" }}
                />
              </Col>
              <Col span={24}>
            <Statistic
              title={t("labels.state.programed_temp")}
              value={temperaturePrograming}
              precision={2}
              suffix="ºC"
              style={{ textAlign: "center" }}
            />
          </Col>
          

            </Col>
            <Col xl={11} lg={11} md={24} style={{marginBottom:10}}>
              <Row>
                <Col span={8}> 
                </Col>
                <Col span={8}> 
                  <H3>{t('headers.control_process.pieces_in_furnace', {value: furnaceArticle && furnaceArticle.length})}</H3>
                </Col>
                <Col span={8}> 
                  <Button 
                    type="link" 
                    size="small" 
                    style={{float: "right"}}
                    onClick={() => timeRunFurnace(10)}
                  >
                    <Icon type="clock-circle" />
                    {t('button.advance_time', {time: 10})}
                  </Button>
                </Col>
              </Row>
              <Table data={furnaceArticle} columns={columnsFurnace}  pagination={{ pageSize: 5 }}/>
            </Col>
            <Col xl={11} lg={24} md={24} style={{marginLeft:"54%"}}>
              <H3>{t('headers.control_process.manufacturing_order')}</H3>
              <Table data={manufacturingList} columns={columnsOrders} pagination={{ pageSize: 4 }} />
            </Col>
        </Row>
    </Wrapper>
  );
};
export default RenderFurnace;
